import { useEffect, useState } from "react";
import { Share, Smartphone, X } from "lucide-react";
import { isIOS, isStandalone } from "@/lib/push";

const FIRST = "camryn_first_done";
const SNOOZE = "camryn_install_snooze_until";
const DONE = "camryn_installed";
const TWO_WEEKS = 14 * 24 * 3600 * 1000;

let deferred = null;
window.addEventListener("beforeinstallprompt", (e) => { e.preventDefault(); deferred = e; });
window.addEventListener("appinstalled", () => localStorage.setItem(DONE, "1"));

export const markFirstDone = () => localStorage.setItem(FIRST, "1");

const isPhone = () => window.matchMedia("(max-width: 1023px) and (pointer: coarse)").matches;
const eligible = () => isPhone() && !isStandalone() && localStorage.getItem(FIRST) && !localStorage.getItem(DONE)
  && Date.now() > Number(localStorage.getItem(SNOOZE) || 0);

export function InstallTip({ trigger }) {
  const [show, setShow] = useState(false);
  const [canPrompt, setCanPrompt] = useState(!!deferred);
  useEffect(() => {
    if (trigger) markFirstDone();
    setShow(eligible());
    const on = () => setCanPrompt(true);
    window.addEventListener("beforeinstallprompt", on);
    return () => window.removeEventListener("beforeinstallprompt", on);
  }, [trigger]);
  if (!show) return null;
  const later = () => { localStorage.setItem(SNOOZE, String(Date.now() + TWO_WEEKS)); setShow(false); };
  const install = async () => {
    deferred.prompt();
    const { outcome } = await deferred.userChoice;
    deferred = null;
    if (outcome === "accepted") { localStorage.setItem(DONE, "1"); setShow(false); } else later();
  };
  return (
    <section className="card p-5 relative rise" data-testid="install-tip">
      <button onClick={later} data-testid="install-tip-close" aria-label="Close" className="absolute top-1.5 right-1.5 h-11 w-11 grid place-items-center rounded-full text-stone-400 hover:bg-stone-100"><X className="h-4 w-4" /></button>
      <div className="flex gap-3 pr-8">
        <Smartphone className="h-5 w-5 text-stone-700 shrink-0 mt-0.5" strokeWidth={1.75} />
        <div>
          <p className="font-display text-lg leading-snug">Keep CAMRYN one tap away</p>
          <p className="text-sm text-stone-600 mt-1" data-testid="install-tip-steps">
            {canPrompt ? "Add CAMRYN to your Home Screen. It opens full-screen like an app, and you can turn on gentle reminders."
              : isIOS() ? <>In Safari, tap <Share className="inline h-4 w-4 -mt-1" aria-label="Share" /> Share, then <strong>Add to Home Screen</strong>. It opens full-screen like an app, and reminders work from there.</>
              : <>Open your browser menu (⋮) and tap <strong>Add to Home screen</strong> or <strong>Install app</strong>.</>}
          </p>
          <div className="mt-4 flex gap-2">
            {canPrompt && <button onClick={install} data-testid="install-tip-install-btn" className="btn-ink px-5 h-11 rounded-full text-sm font-semibold">Add to Home Screen</button>}
            <button onClick={later} data-testid="install-tip-later-btn" className="px-5 h-11 rounded-full border border-stone-200 text-sm font-semibold">Not now</button>
          </div>
        </div>
      </div>
    </section>
  );
}
